import React from 'react';
import { TrendingUpIcon } from 'lucide-react';
export function Proof() {
  return <section aria-labelledby="prueba-titulo" className="w-full bg-sand-100 py-16 sm:py-24" data-id="element-169" data-mp="7qlcehxyd1vl">
      <div className="mx-auto w-full max-w-4xl px-5 text-center sm:px-8" data-id="element-170" data-mp="lq2ygpjv6119">
        <TrendingUpIcon aria-hidden="true" className="mx-auto h-8 w-8 text-ember-600" data-id="element-171" data-mp="lo063yv8nvtd" />
        <h2 id="prueba-titulo" className="mt-6 font-display text-2xl font-extrabold leading-snug text-ink sm:text-3xl" data-id="element-172" data-mp="grsy80ja8a8s">
          En los primeros 7 días, la mayoría de los usuarios reporta que el dolor «sube» de la
          pantorrilla al glúteo.
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-ink/70" data-id="element-173" data-mp="2st96rruxtc3">
          Ese proceso se llama <span className="font-semibold text-ink" data-id="element-174" data-mp="3u4l8uxxa1so1">centralización</span> y es la
          señal número uno de que el nervio está dejando de sufrir y la sanación ha comenzado.
        </p>
      </div>
    </section>;
}